export class User {
    attributes;
    roles;
    passportId;
    constructor(attributes, roles) {
        this.attributes = attributes;
        this.roles = roles;
        this.passportId = attributes.preferred_username;
    }
    get id() {
        return this.attributes.sub;
    }
    get email() {
        return this.attributes.email;
    }
    get name() {
        return this.attributes.name;
    }
    get pasportId() {
        return this.attributes.preferred_username;
    }
    get fullname() {
        return {
            first: this.attributes.given_name,
            last: this.attributes.family_name,
            middle: this.attributes.middle_name,
        };
    }
    hasRole(role) {
        return this.roles.includes(role);
    }
}
